import React, {useEffect, useMemo, useState} from 'react';
import {Link} from 'react-router-dom';
import NavBar from "../../../common/NavBar";
import SideBar from "../../../common/SideBar";
import CssBaseline from '@material-ui/core/CssBaseline';
import EnhancedTable from './tableComponent/EnhancedTable';
import PolicyHoldersService from "../../../services/PolicyHoldersService";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Spinner from "reactjs-simple-spinner";

const PolicyHolders = (props) => {

    const [editButton, setEditButton] = useState(false)
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([])
    const [skipPageReset, setSkipPageReset] = useState(false)


    //view PolicyHolder
    const viewPolicyHolder = (value) => {
        console.log(value);
        //store row record into localStorage
        localStorage.setItem('policyHolderId', JSON.stringify(value));
        props.history.push('/view-policy-holder');

    }

    //view edit PolicyHolder form
    const viewEditPolicyHolder = (value) => {
        console.log(value);
        //store row record into localStorage
        localStorage.setItem('policyHolderId', JSON.stringify(value));
        props.history.push('/edit-policy-holder');

    }




    // We need to keep the table from resetting the pageIndex when we
    // Update data. So we can keep track of that flag with a ref.

    // When our cell renderer calls updateMyData, we'll use
    // the rowIndex, columnId and new value to update the
    // original data
    const updateMyData = (rowIndex, columnId, value) => {
        // We also turn on the flag to not reset the page
        setSkipPageReset(true)
        setData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row
            })
        )
    }

    const columns = useMemo(
        () => [
            {
                Header: 'Firstname',
                accessor: 'first_name',
            },
            {
                Header: 'Surname',
                accessor: 'last_name',
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Contact Number',
                accessor: 'mobile',
            },
            {
                Header: 'Action',
                accessor: 'id',
                Cell: ({value}) => (
                    <span>
        <Link className="btn btn-sm btn-primary " onClick={() => viewPolicyHolder(value)}><i className="fa fa-eye"/> View </Link>
                        <Link className="btn btn-sm btn-success" onClick={() => viewEditPolicyHolder(value)}><i
                            className="fa fa-edit"/> Edit</Link>
                    </span>


                )
            },
        ],
        []
    )

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true);
        let role_based_perm = JSON.parse(localStorage.getItem('role_based_permissions'));
        let direct_perm = JSON.parse(localStorage.getItem('direct_permissions'));
        console.log("role_based: ", role_based_perm);
        console.log("direct perm: ", direct_perm);
        if (role_based_perm === null && false && direct_perm === null && false) {
            setEditButton(false);
        } else if (role_based_perm.length === 0 && direct_perm.length === 0) {
            setEditButton(false);
        } else if (role_based_perm.length > 0) {
            role_based_perm.map((perm, i) => {
                if (perm.name === 'update policy holder') {
                    setEditButton(true);
                }
            })
        } else if (direct_perm.length > 0) {
            direct_perm.map((perm, i) => {
                if (perm.name === 'update policy holder') {
                    setEditButton(true);
                }
            })
        }
        let token = JSON.parse(localStorage.getItem('token'));
        console.log("leads token", token)

        PolicyHoldersService.getAllPolicyHolders()
            .then(res => {
                //return all policy holders onLoad
                if (res.status === 200) {
                    console.log(res);
                    setData(res.data.policyHolders);
                    setLoading(false);
                } else {
                    setData([]);
                    setLoading(false);
                    console.log(res);
                    toast.warning('Loading Failed, Try again \nIf error persists contact System Administrator ');
                }

            })
            .catch(err => {
                toast.warning('Loading Failed, Try again \nIf error persists contact System Administrator ');
                console.log(err);
                setData([]);
                setLoading(false);
            });


    }, []);


    return(
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                            &nbsp;|&nbsp;
                            Leads
                        </ul>
                        <div className="row mt">
                            <div className="card col-lg-12">
                                <div className="content-panel bg-white p-2">
                                    {loading && (
                                        <div className="container">
                                            <form className="loader">
                                                <div className="login-wrap p-5 mt-5">
                                                    <Spinner
                                                        size="large"
                                                        message="Loading data, Please Wait..."
                                                        line-fg-color="#64c3c2"
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    )}
                                    {!loading && (
                                    <div id="table">
                                        {/*  policy_holders table*/}
                                        <CssBaseline/>
                                        <EnhancedTable
                                            columns={[
                                                {
                                                    Header: 'Firstname',
                                                    accessor: 'first_name',
                                                },
                                                {
                                                    Header: 'Surname',
                                                    accessor: 'last_name',
                                                },
                                                {
                                                    Header: 'Email',
                                                    accessor: 'email',
                                                },
                                                {
                                                    Header: 'Contact Number',
                                                    accessor: 'mobile',
                                                },
                                                {
                                                    Header: 'Action',
                                                    accessor: 'id',
                                                    Cell: ({value}) => (
                                                        <span>
        <Link className="btn btn-sm btn-primary " onClick={() => viewPolicyHolder(value)}><i className="fa fa-eye"/> View </Link>
                                                            {editButton && (
                                                                <Link className="btn btn-sm btn-success"
                                                                      onClick={() => viewEditPolicyHolder(value)}><i
                                                                    className="fa fa-edit"/> Edit</Link>
                                                            )}
                    </span>


                                                    )
                                                },
                                            ]}
                                            data={data}
                                            setData={setData}
                                            updateMyData={updateMyData}
                                            skipPageReset={skipPageReset}
                                        />
                                    </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>






    )
}

export default PolicyHolders;
